import { Tooltip } from 'react-tippy'

const CustomTooltip = ({ children, title, popperOptions, ...props }) => (
  <Tooltip
    title={title}
    animation="scale"
    trigger="mouseenter"
    position="bottom"
    popperOptions={popperOptions}
    duration={200}
    arrow
    delay={[0, 50]}
    arrowType="sharp"
    theme="light"
    maxWidth={220}
    size="small"
    interactive
    hideOnClick={false}
    {...props}
  >
    {children}
  </Tooltip>
)

export default CustomTooltip
